import { $Formutil, connect, EasyField } from 'react-bootstrap-formutil';
import FormGroup from 'components/FormGroup';
import BaseAddress from 'components/forms/AddressInfo';
import CountrySelect from 'components/forms/CountrySelect';
import { SameDeliveryAndResidence } from 'components/forms/DeliveryAddress';
import { CustomerInfoKeyType, HomeAddressTypeEnum } from 'types/customer';
import { BaseHomeAddressProps, UsaHomeAddressFormutil } from '../type';

export interface UsaHomeAddressProps extends Omit<BaseHomeAddressProps, 'prefix'> {
    $formutil: $Formutil<UsaHomeAddressFormutil>;
    hideMailAddress?: boolean;
}

export const getUsaHomeAddressFields = (needHomeAddressType: boolean = true) => {
    const baseFields: CustomerInfoKeyType[] = [
        'home_address',
        'home_address2',
        'home_city',
        'home_postal',
        'home_state_code',
        'same_delivery_and_residence'
    ];

    return needHomeAddressType ? baseFields.concat('home_address_type') : baseFields;
};

const UsaHomeAddress: React.FC<UsaHomeAddressProps> = ({ hideMailAddress, disabled }) => {
    return (
        <>
            <BaseAddress
                prefix="home"
                hasPostalCode={false}
                isProvince={false}
                prefixStreetPlaceholder={__('Home')}
                disabled={disabled}
            />
            {/* disabled仅展示，标识temporary_country */}
            <FormGroup label={__('Country')} $defaultValue="USA" name="temporary_country">
                <CountrySelect isSSN disabled fieldName="temporary_country" />
            </FormGroup>
            {!hideMailAddress && <SameDeliveryAndResidence disabled={disabled} />}
            <EasyField name="home_address_type" type="hidden" $defaultValue={HomeAddressTypeEnum.USA} />
        </>
    );
};

export default connect(UsaHomeAddress);
